import { render, staticRenderFns } from "./BlockchainIntegrationTestDashboard.vue?vue&type=template&id=7675ba22&scoped=true"
import script from "./BlockchainIntegrationTestDashboard.vue?vue&type=script&lang=js"
export * from "./BlockchainIntegrationTestDashboard.vue?vue&type=script&lang=js"
import style0 from "./BlockchainIntegrationTestDashboard.vue?vue&type=style&index=0&id=7675ba22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7675ba22",
  null
  
)

export default component.exports